module.exports = __webpack_public_path__ + "img/whatsapp.1a9c7cf3.png";